/* assets/gcitypartners-delivery-lifecycle.js — GCITYPARTNERS-DELIVERY-LIFECYCLE-01 */
(function (window, document) {
  'use strict';
  var KEY = '__GCITYPARTNERS_DELIVERY_LIFECYCLE__';
  var ROOT = '[data-gcp-delivery-lifecycle]';
  var API_ORIGIN = 'https://api.glhksolution.com';
  var mounted = new WeakSet();
  const deliveryReadVersions = new WeakMap();
  let deliveryEpoch = 0;

  if (window[KEY] && typeof window[KEY].mountAll === 'function') {
    window[KEY].mountAll(document);
    return;
  }

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }
  function isZh() {
    return /^zh/i.test(clean(document.documentElement.lang));
  }
  /**
   * @param {string} zh
   * @param {string} en
   */
  function words(zh, en) {
    return isZh() ? zh : en;
  }
  function session() {
    var value = window.LittleGWebSession;
    return value && typeof value.authenticatedFetch === 'function' ? value : null;
  }
  function captureDeliveryScope() {
    const owner = session();
    const current = owner && typeof owner.getState === 'function' ? owner.getState() : null;
    const subject =
      current && current.status === 'authenticated'
        ? clean(current.profile && current.profile.id)
        : '';

    return owner && subject ? { owner: owner, subject: subject, epoch: deliveryEpoch } : null;
  }

  function currentDeliveryScope(root, scope) {
    if (!scope || !root.isConnected || scope.epoch !== deliveryEpoch) {
      return false;
    }

    const current = captureDeliveryScope();
    return current && current.owner === scope.owner && current.subject === scope.subject;
  }

  function trustedEndpoint(root) {
    var raw = clean(root.getAttribute('data-gcp-delivery-endpoint'));
    if (!raw) return '';
    try {
      var url = new URL(raw, API_ORIGIN);
      return url.origin === API_ORIGIN && url.pathname.indexOf('/v1/gcitypartners/') === 0
        ? url.toString()
        : '';
    } catch (_error) {
      return '';
    }
  }
  async function requestJson(root, options) {
    var nativeSession = session();
    var url = trustedEndpoint(root);
    if (!nativeSession || !url) throw new Error('native_session_unavailable');
    var init = Object.assign({ headers: { Accept: 'application/json' } }, options || {});
    if (init.body && typeof init.body !== 'string') {
      init.body = JSON.stringify(init.body);
      init.headers = Object.assign({}, init.headers, { 'Content-Type': 'application/json' });
    }
    var response = await nativeSession.authenticatedFetch(url, init);
    var payload = await response.json().catch(function () {
      return {};
    });
    if (!response.ok || !payload || payload.ok !== true) {
      var error = new Error(
        clean(payload && payload.error) || clean(payload && payload.message) || 'request_failed'
      );
      error.status = response.status;
      throw error;
    }
    return payload;
  }
  function list(value) {
    return Array.isArray(value) ? value : [];
  }
  function splitEvidence(value) {
    var seen = Object.create(null);
    return clean(value)
      .split(/[\n,]+/)
      .map(clean)
      .filter(function (item) {
        if (!item || seen[item]) return false;
        seen[item] = true;
        return true;
      })
      .slice(0, 12);
  }
  function status(root, text, isError) {
    var node = root.querySelector('[data-gcp-delivery-status]');
    if (node) {
      node.textContent = text || '';
      node.setAttribute('data-error', isError ? 'true' : 'false');
    }
  }
  function label(item) {
    return [
      clean(item.title) || clean(item.product_handle) || words('專業項目', 'Professional Project'),
      '…' + clean(item.job_id).slice(-6),
    ].join(' · ');
  }
  function readback(root, item, target) {
    var node = target || root.querySelector('[data-gcp-delivery-readback]');
    if (!node) return;
    node.replaceChildren();
    if (!item) return;
    var delivery = item.delivery && typeof item.delivery === 'object' ? item.delivery : null;
    var qa = item.qa && typeof item.qa === 'object' ? item.qa : null;
    [
      words('工作狀態：', 'Work status: ') + clean(item.status || '—'),
      words('商業狀態：', 'Commercial status: ') + clean(item.commercial_status || '—'),
      delivery
        ? words('最新進度：', 'Latest progress: ') +
          (delivery.progress_percent == null ? '—' : String(delivery.progress_percent) + '%')
        : words(
            '本次回應未提供 Provider 交付內容。',
            'This response did not provide Provider delivery details.'
          ),
      qa
        ? words('最新 QA：', 'Latest QA: ') +
          clean(qa.qa_result || '—') +
          ' · ' +
          clean(qa.client_acceptance || '—')
        : '',
    ]
      .filter(Boolean)
      .forEach(function (text) {
        var p = document.createElement('p');
        p.textContent = text;
        node.appendChild(p);
      });
    if (delivery && clean(delivery.delivery_note)) {
      var note = document.createElement('p');
      note.textContent = words('交付說明：', 'Delivery note: ') + clean(delivery.delivery_note);
      node.appendChild(note);
    }
    if (delivery && Array.isArray(delivery.evidence_files) && delivery.evidence_files.length) {
      var evidence = document.createElement('p');
      evidence.textContent =
        words('證據／檔案：', 'Evidence / files: ') + delivery.evidence_files.join(' · ');
      node.appendChild(evidence);
    }
  }
  function selectedItem(root) {
    var select = root.querySelector('[data-gcp-delivery-form] select[name="job_id"]');
    var items = root.__gcpDeliveryItems || [];
    var jobId = clean(select && select.value);
    return (
      items.find(function (item) {
        return clean(item && item.job_id) === jobId;
      }) || null
    );
  }
  function renderItems(root, items) {
    root.__gcpDeliveryItems = list(items);
    var select = root.querySelector('[data-gcp-delivery-form] select[name="job_id"]');
    if (!select) return;
    select.replaceChildren();
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = words('選擇已獲項目', 'Select awarded project');
    select.appendChild(placeholder);
    items.forEach(function (item) {
      var option = document.createElement('option');
      option.value = clean(item.job_id);
      option.textContent = label(item);
      select.appendChild(option);
    });
    readback(root, null);
    renderReadonlyDelivery(root);
  }
  function renderReadonlyDelivery(root, preferredJobId) {
    if (root.getAttribute('data-gcp-delivery-mode') !== 'buyer') return;

    const dashboard = root.closest('[data-gcitypartners-dashboard]');
    if (!dashboard) return;

    const select = dashboard.querySelector('[data-gcp-delivery-view-select]');
    const target = dashboard.querySelector('[data-gcp-project-delivery-readback]');
    if (!select || !target) return;

    const scope = captureDeliveryScope();
    const items = scope ? list(root.__gcpDeliveryItems) : [];
    const previous = typeof preferredJobId === 'string' ? preferredJobId : select.value;

    select.replaceChildren();

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = items.length
      ? words('選擇專案查看交付快照', 'Select a project to review its delivery snapshot')
      : words('本次尚無可顯示資料', 'No display data is currently available');
    select.appendChild(placeholder);

    items.forEach(function (item) {
      const option = document.createElement('option');
      option.value = clean(item.job_id);
      option.textContent = label(item);
      select.appendChild(option);
    });

    select.disabled = items.length === 0;

    const selected = items.find(function (item) {
      return clean(item.job_id) === previous;
    });

    select.value = selected ? clean(selected.job_id) : '';
    readback(root, selected || null, target);

    if (!selected) {
      const message = document.createElement('p');
      message.textContent = scope
        ? words(
            '請選擇專案。此處只顯示本次交付服務返回的資料，不能據此判斷完整記錄是否存在。',
            'Select a project. This view only shows data returned by the delivery service, not whether complete records exist.'
          )
        : words('登入後可核對交付資料。', 'Sign in to review delivery data.');
      target.appendChild(message);
    }
  }

  function setBuyerFormVisible(root, visible) {
    if (root.getAttribute('data-gcp-delivery-mode') !== 'buyer') return;

    const form = root.querySelector('[data-gcp-delivery-form]');
    if (form) form.hidden = !visible;
  }

  async function load(root) {
    const form = root.querySelector('[data-gcp-delivery-form]');
    if (form && form.getAttribute('aria-busy') === 'true') return;

    const version = (deliveryReadVersions.get(root) || 0) + 1;
    deliveryReadVersions.set(root, version);

    const scope = captureDeliveryScope();
    setBuyerFormVisible(root, false);
    renderItems(root, []);

    if (!scope) {
      status(
        root,
        words('登入後可核對交付與驗收資料。', 'Sign in to review delivery and acceptance data.'),
        true
      );
      return;
    }

    const isCurrent = function () {
      return currentDeliveryScope(root, scope) && deliveryReadVersions.get(root) === version;
    };

    status(root, words('正在載入交付資料…', 'Loading delivery data…'));

    try {
      const result = await requestJson(root);
      if (!isCurrent()) return;

      if (
        !Array.isArray(result.items) ||
        !result.items.every(function (item) {
          return (
            item &&
            typeof item === 'object' &&
            !Array.isArray(item) &&
            typeof item.job_id === 'string' &&
            item.job_id.trim()
          );
        })
      ) {
        throw new Error('invalid_delivery_response');
      }

      renderItems(root, result.items);
      setBuyerFormVisible(root, result.items.length > 0);
      status(
        root,
        result.items.length
          ? ''
          : words(
              '本次查詢未返回可處理的已獲項目。',
              'No actionable awarded projects were returned by this request.'
            )
      );
    } catch (error) {
      if (!isCurrent()) return;

      renderItems(root, []);
      status(
        root,
        clean(error && error.message) === 'provider_not_approved'
          ? words(
              '此帳戶尚未獲准 Provider 工作。',
              'This account is not approved for Provider work.'
            )
          : words(
              '暫時無法載入交付資料，這不代表沒有記錄。',
              'Delivery data is unavailable. This does not mean no records exist.'
            ),
        true
      );
    }
  }
  function providerPayload(form) {
    var rawProgress = clean(form.elements.progress_percent && form.elements.progress_percent.value);
    return {
      job_id: clean(form.elements.job_id.value),
      progress_percent: rawProgress ? Number(rawProgress) : null,
      delivery_note: clean(form.elements.delivery_note && form.elements.delivery_note.value),
      evidence_files: splitEvidence(
        form.elements.evidence_files && form.elements.evidence_files.value
      ),
    };
  }
  function buyerPayload(form) {
    return {
      job_id: clean(form.elements.job_id.value),
      qa_result: clean(form.elements.qa_result && form.elements.qa_result.value),
      qa_comment: clean(form.elements.qa_comment && form.elements.qa_comment.value),
      client_acceptance: clean(
        form.elements.client_acceptance && form.elements.client_acceptance.value
      ),
    };
  }
  async function submit(root, form) {
    if (form.getAttribute('aria-busy') === 'true') return;

    const scope = captureDeliveryScope();
    if (!scope) {
      status(
        root,
        words(
          '請先登入，再核對並提交驗收。',
          'Sign in before reviewing and submitting acceptance.'
        ),
        true
      );
      return;
    }

    var mode = clean(root.getAttribute('data-gcp-delivery-mode'));
    var button = form.querySelector('button[type="submit"]');
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      status(
        root,
        words('請先完成所有必填選項。', 'Complete all required selections first.'),
        true
      );
      return;
    }
    var body = mode === 'provider' ? providerPayload(form) : buyerPayload(form);
    if (!body.job_id) {
      status(root, words('請先選擇項目。', 'Select a project first.'), true);
      return;
    }

    deliveryReadVersions.set(root, (deliveryReadVersions.get(root) || 0) + 1);

    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    status(
      root,
      mode === 'provider'
        ? words('正在儲存交付更新…', 'Saving delivery update…')
        : words('正在提交 QA / 驗收…', 'Submitting QA / acceptance…')
    );
    try {
      var result = await requestJson(root, { method: 'POST', body: body });
      if (!currentDeliveryScope(root, scope)) return;

      if (
        result.item &&
        (typeof result.item !== 'object' ||
          Array.isArray(result.item) ||
          clean(result.item.job_id) !== clean(body.job_id))
      ) {
        throw new Error('invalid_delivery_response');
      }

      if (result.item) {
        var items = list(root.__gcpDeliveryItems).filter(function (item) {
          return clean(item.job_id) !== clean(result.item.job_id);
        });
        items.unshift(result.item);
        renderItems(root, items);
        var select = form.elements.job_id;
        if (select) select.value = clean(result.item.job_id);
        readback(root, result.item);
        renderReadonlyDelivery(root, clean(result.item.job_id));
      }
      status(
        root,
        result.completed === true
          ? words(
              'QA 已通過且客戶已驗收，Project 已完成。',
              'QA approved and client accepted. The Project is completed.'
            )
          : mode === 'provider'
            ? words('交付更新已儲存。', 'Delivery update saved.')
            : words(
                'QA / 驗收結果已儲存；尚未完成 Project。',
                'QA / acceptance saved; the Project is not completed yet.'
              )
      );

      if (mode === 'buyer') {
        root.dispatchEvent(
          new CustomEvent('gcp:delivery-saved', {
            bubbles: true,
            detail: {
              job_id: clean(body.job_id),
              subject: scope.subject,
            },
          })
        );
      }
    } catch (error) {
      if (!currentDeliveryScope(root, scope)) return;

      var code = clean(error && error.message);
      var message =
        code === 'delivery_update_required'
          ? words(
              '必須先有 Provider 交付更新才可 QA。',
              'A Provider delivery update is required before QA.'
            )
          : code === 'acceptance_requires_approved_qa'
            ? words(
                'QA 未 Approved 時不能標記 Accepted。',
                'Client acceptance cannot be Accepted until QA is Approved.'
              )
            : code === 'invalid_qa_result' || code === 'invalid_client_acceptance'
              ? words(
                  '請明確選擇 QA 與客戶驗收結果。',
                  'Select explicit QA and client acceptance results.'
                )
              : code === 'delivery_job_completed'
                ? words(
                    '此 Project 已完成，不能再修改。',
                    'This Project is already completed and cannot be changed.'
                  )
                : code === 'delivery_job_not_actionable'
                  ? words(
                      '此 Project 當前狀態不可進行此操作，請重新載入。',
                      'This Project is not actionable in its current state. Reload first.'
                    )
                  : code === 'delivery_state_conflict'
                    ? words(
                        'Project 狀態剛剛已變更，請重新載入後再操作。',
                        'The Project state changed. Reload before retrying.'
                      )
                    : words(
                        '未能確認儲存結果。請先重新讀取交付資料，再決定是否重試，避免重複提交。',
                        'The save result could not be confirmed. Reload delivery data before deciding whether to retry, to avoid duplicate submissions.'
                      );
      status(root, message, true);
    } finally {
      if (currentDeliveryScope(root, scope)) {
        form.setAttribute('aria-busy', 'false');
        if (button) button.disabled = false;
      }
    }
  }
  function mount(root) {
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    var form = root.querySelector('[data-gcp-delivery-form]');
    if (!form) return;
    var select = form.elements.job_id;
    if (select)
      select.addEventListener('change', function () {
        readback(root, selectedItem(root));
        renderReadonlyDelivery(root, clean(select.value));
      });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      void submit(root, form);
    });

    if (root.getAttribute('data-gcp-delivery-mode') === 'buyer') {
      const dashboard = root.closest('[data-gcitypartners-dashboard]');
      const readonlySelect =
        dashboard && dashboard.querySelector('[data-gcp-delivery-view-select]');

      if (readonlySelect) {
        readonlySelect.addEventListener('change', function () {
          renderReadonlyDelivery(root);
        });
      }
    }

    load(root);
  }
  /** @param {ParentNode | null} [scope] */
  function mountAll(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(mount);
  }
  function refresh(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(ROOT), function (root) {
      if (mounted.has(root)) load(root);
      else mount(root);
    });
  }

  var api = Object.freeze({ mountAll: mountAll, refresh: refresh });
  window[KEY] = api;
  document.addEventListener('littleg:web-session-change', function () {
    deliveryEpoch += 1;

    document.querySelectorAll(ROOT).forEach(function (root) {
      deliveryReadVersions.set(root, (deliveryReadVersions.get(root) || 0) + 1);

      const form = root.querySelector('[data-gcp-delivery-form]');
      if (form) {
        form.reset();
        form.setAttribute('aria-busy', 'false');

        const button = form.querySelector('button[type="submit"]');
        if (button) button.disabled = false;
      }

      renderItems(root, []);
    });

    refresh(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target || document);
  });
  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        mountAll(document);
      },
      { once: true }
    );
  else mountAll(document);
})(window, document);
